module.exports = __webpack_public_path__ + "static/media/jbportfolio.f45fe080.jpg";